import { Grid } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { BsGear, BsCardChecklist, BsChevronDown } from 'react-icons/bs'
import { AiOutlineInfoCircle, AiOutlineSwap, AiOutlineCheckCircle } from 'react-icons/ai'
import { BsArrowsAngleContract } from "react-icons/bs";

import Button from '../../Component/Button'
import { useSelector } from 'react-redux'
import DropDown from '../../Component/DropDown'
import OutsideClickHandler from 'react-outside-click-handler'
import { callWeb3Approval, callWeb3Balance, callWeb3Decimals, callWeb3SetLimit, callWeb3Swap, getNetworkPairs, getNetworks, redirectToMetamask, sendTransDetails, switchNetwork, walletConnectHandler } from '../../Utility/helpers'
import Web3 from 'web3'
import { useDispatch } from 'react-redux'
import { API, dark_mode, set_admin, set_balance, set_decimal, set_from, set_limit, set_netowrks, set_networkPairs } from '../../Utility/constants'
import toast from 'react-hot-toast'
import { formatUnits, parseUnits } from "@ethersproject/units";
import Swal from 'sweetalert2'
import classNames from 'classnames'
import backgroundImage from '../../Styles/Assets/backgorund_day.png'
import ModalComponent from '../../Component/ModalComponent'
import { BiArrowBack, BiWindowOpen } from "react-icons/bi";
import copy from 'copy-to-clipboard'
import ReactTooltip from "react-tooltip";
import metamaskIcon from '../../Styles/Assets/metamask-icon.png'
import Axios from 'axios'

const Swap = () => {
    const networkPairs = useSelector(state => state.networkPairs)
    const networks = useSelector(state => state.networks)
    const balance = useSelector(state => state.balance)
    const dec = useSelector(state => state.dec)
    const limit = useSelector(state => state.limit)
    const mode = useSelector(state => state.mode)
    const acc = useSelector(state => state.acc)
    const swapLoading = useSelector(state => state.swapLoading)
    const [from, setFrom] = useState(Object.keys(networkPairs)[0])
    const [to, setTo] = useState(localStorage.getItem("from") && networkPairs[[localStorage.getItem("from")]] ? Object.keys(networkPairs[localStorage.getItem("from")]?.available_pair)[0] : Object.keys(networkPairs[from]?.available_pair)[0])
    const [availablePairs, setAvailablePairs] = useState(localStorage.getItem("from") && networkPairs[[localStorage.getItem("from")]] ? Object.keys(networkPairs[localStorage.getItem("from")].available_pair) : Object.keys(networkPairs[from].available_pair))
    const [availableFrom, setAvailableFrom] = useState(Object.keys(networkPairs))
    const outsideRef = useRef(false)
    const [fromDropDown, setFromDropDown] = useState(false)
    const [toDropDown, setToDropDown] = useState(false)
    const [amt, setAmt] = useState("")
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [title, setTitle] = useState("SET LIMIT")
    const [currPercent, setCurrPercent] = useState(null)
    const [color, setColor] = useState("")
    const [amtForInput, setAmtForInput] = useState("")
    const [clickStatus, setClickStatus] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const [txnId, setTxnId] = useState("")
    const [inputError, setInputError] = useState("")

    let streamFeeStorage = localStorage.getItem("from") && networkPairs[[localStorage.getItem("from")]] ? (amt * (networks[localStorage.getItem("from")].stream_fee / 100)).toFixed(2) : ''
    let streamFee = (amt * (networks[from].stream_fee / 100)).toFixed(2)

    let userAcc = useSelector(state => {
        return state.acc
    })

    useEffect(() => {
        window.onbeforeunload = function () {
            if (loading) {
                return "Leaving this page will reset the wizard";
            } else {
                window.onbeforeunload = null;
            }
        }
    }, [loading])

    const changeHandler = (type, val) => {
        switch (type) {
            case "AMT":
                if (!isNaN(val)) {
                    setInputError(false)
                    setAmt(val)
                    setAmtForInput(val)
                    setCurrPercent(null)
                }
        }
    }

    useEffect(() => {
        window.ethereum && window.ethereum.on('chainChanged', (chainId) => {
            if (localStorage.getItem("from")) {
                if (networks[localStorage.getItem("from")].chainID === chainId && acc) {
                    checkApprovalLimit(localStorage.getItem("from"))
                }
            } else {
                if (networks[from].chainID === chainId && acc) {
                    checkApprovalLimit(from)
                }
            }

        });
        if (localStorage.getItem("from")) {
            if (acc && networks[localStorage.getItem("from")].chainID === window.ethereum.chainId) {
                checkApprovalLimit(localStorage.getItem("from"))
            }
        } else {
            if (acc && networks[from].chainID === window.ethereum.chainId) {
                checkApprovalLimit(from)
            }
        }

    }, [acc])

    useEffect(() => {
        switchNetwork(localStorage.getItem("from") ? localStorage.getItem("from") : from, networks)
    }, [])

    useEffect(() => {
        if (from in networks) {
            window.web3 = new Web3(window.ethereum)
        }
    }, [from])

    useEffect(() => {
        titleHandler()
    }, [amt, limit, loading])
    const percentHandler = (val) => {
        switch (val) {
            case "25%":
                setAmt((balance * 0.25).toString().match(/^\d+(?:\.\d{0,5})?/).toString())
                setCurrPercent(val)
                break;
            case "50%":
                setAmt((balance * 0.50).toString().match(/^\d+(?:\.\d{0,5})?/).toString())
                setCurrPercent(val)
                break;
            case "75%":
                setAmt((balance * 0.75).toString().match(/^\d+(?:\.\d{0,5})?/).toString())
                setCurrPercent(val)
                break;
            case "MAX":
                setAmt(balance.toString())
                setCurrPercent(val)
                break;
        }
    }
    const fromChangeHandler = async (val) => {
        let allNetwork = await getNetworks()
        let allPairs = await getNetworkPairs()
        dispatch({ type: set_netowrks, payLoad: allNetwork })
        dispatch({ type: set_networkPairs, payLoad: allPairs })

        if (!allPairs[val]?.maintenance) {
            try {
                setLoading(true)
                let res = await switchNetwork(val, networks)
                if (res) {
                    localStorage.setItem("from", val)
                    localStorage.setItem("to", Object.keys(networkPairs[val].available_pair)[0])
                    setAmt('0')
                    setFrom(val)
                    dispatch({ type: set_from, payLoad: val })
                    setTo(Object.keys(networkPairs[val].available_pair)[0])
                    setAvailablePairs(Object.keys(networkPairs[val].available_pair))
                    checkApprovalLimit(val)
                    setLoading(false)
                    setClickStatus(!clickStatus)
                } else {
                    if (val === "ETH") {
                        localStorage.setItem("from", val)
                        localStorage.setItem("to", Object.keys(networkPairs[val].available_pair)[0])
                        setAmt('0')
                        setFrom(val)
                        dispatch({ type: set_from, payLoad: val })
                        setTo(Object.keys(networkPairs[val].available_pair)[0])
                        setAvailablePairs(Object.keys(networkPairs[val].available_pair))
                        checkApprovalLimit(val)
                        setLoading(false)

                        setClickStatus(!clickStatus)
                    }

                }

                setLoading(false)


            } catch (err) {
                toast.error("User Rejected")
                setLoading(false)

            }
        } else {
            toast.error(`${val} is under maintenance.`)
        }

    }

    const tochangeHandler = async (val) => {
        let allNetwork = await getNetworks()
        let allPairs = await getNetworkPairs()
        dispatch({ type: set_netowrks, payLoad: allNetwork })
        dispatch({ type: set_networkPairs, payLoad: allPairs })
        if (!allPairs[val]?.maintenance) {
            setTo(val)
        } else {
            toast.error(`${val} is under maintenance.`)
        }
    }
    const titleHandler = () => {
        if (loading) {
            setTitle("Please wait")
            return
        }
        if (Number(limit) === 0) {
            setTitle("SET LIMIT")
            setColor("blue")
            return
        } if (Number(limit) < Number(amt)) {
            setTitle("INCREASE LIMIT")
            return
        } if (Number(limit) >= Number(amt)) {
            setTitle("SWAP NOW")
            setColor("red")
            return
        }
    }
    const checkApprovalLimit = async (from) => {
        // console.log('In Limit')
        try {
            if (acc) {
                dispatch({ type: set_balance, payLoad: "" })
                let limit = await callWeb3Approval(networks[from].base_contract, acc, networks[from].cross_chain_contract, from)
                let balance = await callWeb3Balance(acc, from, networks[from].base_contract)
                let dec = await callWeb3Decimals(from, networks[from].base_contract)
                balance = formatUnits(balance, dec)
                limit = formatUnits(limit, dec)
                dispatch({ type: set_balance, payLoad: balance })
                dispatch({ type: set_limit, payLoad: limit })
                dispatch({ type: set_decimal, payLoad: Number(dec) })
                setLoading(false)
            }
        } catch (error) {
            toast.error(error.message)
            setLoading(false)
        }
    }


    useEffect(() => {
        if (currPercent != null) {
            percentHandler(currPercent)
        }
    }, [balance])

    const clear = () => {
        setAmt("0.00")
        setCurrPercent(null)
    }
    const onSwap = async () => {

        // console.log("---------------------------->")
        if (!networkPairs[from]?.maintenance && !networkPairs[to]?.maintenance) {
            console.log("--------------------------->",networkPairs[from])
            console.log("<---------------------------",networkPairs[to])
            setLoading(true)
            Swal.fire({
                title: '<strong>Warning!</u></strong>',
                icon: 'warning',
                html:
                    'Closing the Stream Bridge swapping window while processing the request may abort the transaction. Please wait for the swapping process to complete before closing.',
                focusConfirm: false,
                confirmButtonColor: "#EE31AF",
                confirmButtonText:
                    'Agree',
            }).then(async (res) => {
                let gasfee = ""
                let feeNetwork = localStorage.getItem('from') ? localStorage.getItem('from') : from
                if (feeNetwork === "MATIC") {
                    let gas = await Axios.get("https://api.polygonscan.com/api?module=gastracker&action=gasoracle&apikey=WTMH6NW7W15SND2K5EFQD88VFIQTD1FK7F")
                    if (gas.status === 200) {
                        let gasValue_Gwei = Number(Web3.utils.toWei(gas.data.result.FastGasPrice)) / 1000000000
                        gasfee = gasValue_Gwei.toString()
                    }

                }
                if (feeNetwork === "FTM") {
                    let gas = await Axios.get("https://api.ftmscan.com/api?module=gastracker&action=gasoracle&apikey=GZZHIHDHGAFXUF6XIZYY83MUYAHABSCE5E")
                    if (gas.status === 200) {
                        gasfee = Number(Web3.utils.toWei(gas.data.result.ProposeGasPrice.toString())) / 1000000000
                        let splitNumber = gasfee.toString().split('.')
                        gasfee = Web3.utils.toBN(splitNumber[0])
                    }
                }
                if (feeNetwork === "BSC") {
                    let gas = await Axios.get("https://api.bscscan.com/api?module=gastracker&action=gasoracle&apikey=5RHRZC37EFJ2F4GNHFTT86238Z8TE1C7HD")
                    if (gas.status === 200) {
                        gasfee = Number(Web3.utils.toWei(gas.data.result.ProposeGasPrice.toString())) / 1000000000
                        let splitNumber = gasfee.toString().split('.')
                        gasfee = Web3.utils.toBN(splitNumber[0])
                    }

                }

                if (parseInt(amt) > parseInt(balance)) {
                    toast.error("insufficient balance.")
                    setLoading(false)

                } else if (amt != "") {
                    dispatch({ type: "SWAP_LOADING", payLoad: true })

                    let baseContract = localStorage.getItem("from") ? networks[localStorage.getItem("from")].base_contract : networks[from].base_contract
                    let baseFrom = localStorage.getItem("from") ? localStorage.getItem("from") : from
                    let crossChainContract = localStorage.getItem("from") ? networks[localStorage.getItem("from")].cross_chain_contract : networks[from].cross_chain_contract
                    let swapFee = localStorage.getItem("from") ? networkPairs[localStorage.getItem("from")].available_pair[to].gas_fee : networkPairs[from].available_pair[to].gas_fee
                    console.log("---------------------------->")
                    try {
                        let amount = parseUnits(amt, dec)
                        if (limit === 0) {
                            // Set initial limit
                            let res = await callWeb3SetLimit(baseContract, amount, crossChainContract, baseFrom, acc, gasfee, swapFee)
                            await checkApprovalLimit(baseFrom)

                            setLoading(false)
                            dispatch({ type: "SWAP_LOADING", payLoad: false })

                            setAmt('')

                            return
                        }
                        if (Number(limit) >= Number(amt)) {
                            let res = await callWeb3Swap(baseFrom, crossChainContract, baseContract, amount, to, swapFee, gasfee)
                            console.log(baseFrom+"---------------------------->"+to)
                            clear()
                            let confirm = await sendTransDetails({ pair_name: `${baseFrom}-${to}`, from_network: baseFrom, trx_id: res.transactionHash })
                            setTxnId(confirm)

                            setModalOpen(true)
                            await checkApprovalLimit(baseFrom)
                            setLoading(false)
                            dispatch({ type: "SWAP_LOADING", payLoad: false })

                            setAmt('')
                            return
                        }
                        if (Number(limit) <= Number(amt)) {
                            let res = await callWeb3SetLimit(baseContract, amount, crossChainContract, baseFrom, acc, gasfee, swapFee)
                            await checkApprovalLimit(baseFrom)
                            setLoading(false)
                            dispatch({ type: "SWAP_LOADING", payLoad: false })

                            setAmt('')

                            return
                        }

                    } catch (error) {
                        // debugger
                        if (error.message.includes("Transaction has been reverted by the EVM")) {
                            toast.error("Transaction has been reverted by the EVM, please try again.");
                            setLoading(false)
                            setAmt('')
                            return
                        } else if (error.message.includes("Returned values aren't valid, did it run Out of Gas? You might also")) {
                            toast.error("Please try again later we are facing higher traffic on blockchain");
                            setLoading(false)
                            setAmt('')
                            return

                        } else if (error.message.includes("a is undefined")) {
                            toast.error("MetaMask Tx Signature: User denied transaction signature.");
                            setLoading(false)
                            return

                        }
                        else if (error.message.includes("insufficient funds for transfer")) {
                            toast.error("insufficient funds for transfer.");
                            setLoading(false)
                            return

                        } else if (error.message.includes("insufficient funds for gas")) {
                            toast.error("insufficient funds for gas.");
                            setLoading(false)
                            return
                        } else {
                            toast.error(error.message)
                            setLoading(false)

                        }
                        setLoading(false)
                    }
                } else {
                    setInputError(true)
                    setLoading(false)
                    setAmt('')

                }
            }).catch((error) => {
                toast.error(error.message)
                setLoading(false)
            })
        } else {
            if (networkPairs[from]?.maintenance) {
                toast.error(`${from} is under maintenance.`)
            }
            else if (networkPairs[to]?.maintenance) {
                toast.error(`${to} is under maintenance.`)

            }

        }
    }

    const addToken = async () => {
        let userAgent = navigator.userAgent;
        let browserName;
        if (userAgent.match(/firefox|fxios/i)) {
            window.location.reload()
        }

        try {
            // debugger
            let check = redirectToMetamask()
            // console.log(networks[localStorage.getItem('from')], " networks[localStorage.getItem('from')]")
            if (!check && userAcc) {
                const { base_contract, network, logo_url, token_name } = localStorage.getItem('from') ? networks[localStorage.getItem('from')] : networks[from]
                // wasAdded is a boolean. Like any RPC method, an error may be thrown.
                const tokenAddress = base_contract;
                const tokenSymbol = token_name;
                const tokenDecimals = 18;
                const tokenImage = logo_url;
                await window.ethereum.request({
                    method: 'wallet_watchAsset',
                    params: {
                        type: 'ERC20', // Initially only supports ERC20, but eventually more!
                        options: {
                            address: tokenAddress, // The address that the token is at.
                            symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
                            decimals: tokenDecimals, // The number of decimals in the token
                            image: "https://s2.coinmarketcap.com/static/img/coins/64x64/17464.png", // A string url of the token logo
                        },
                    },
                });
            } else {
                toast.error("Please connect to Metamask")
            }

        } catch (error) {
            toast.error(error.message);
        }
    }

    const percentOptions = ["25%", "50%", "75%", "MAX"]

    const receivingAddressClass = classNames({
        home_Swap_receiving_address: true,
        dark: mode === dark_mode ? true : false
    })
    const swapFieldsrClass = classNames({
        swap_fields: true,
        dark: mode === dark_mode ? true : false
    })
    const inputClass = classNames({
        input_class: true,
        dark: mode === dark_mode ? true : false
    })

    const whiteBgClass = classNames({
        form_white_bg: true,
        dark: mode === dark_mode ? true : false
    })

    const swapIcon = classNames({
        swap_icon: true,
        dark: mode === dark_mode ? true : false,
        click: clickStatus
    })

    const transactionDetailModal = (
        txnId !== "" &&
        <div style={{ height: 350 }} className="transactionModal">
            <div style={{ display: 'flex', alignitems: "center", flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <AiOutlineCheckCircle style={{
                        color: mode === dark_mode ? '#fff' : '#EE31AF', flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '5%',
                    }} size={60} />
                </div>
                <div style={{ marginTop: '5%' }}>
                    <p style={{
                        textAlign: 'center',
                        color: mode === dark_mode ? '#fff' : '#EE31AF',
                        fontSize: 25
                    }}>{txnId.data.message}</p>
                    <p style={{ textAlign: 'center', color: mode === dark_mode ? '#fff' : '#EE31AF', }}>copy txid to check status</p>

                    <div style={{ display: 'flex', justifyContent: 'center', fontWeight: "500", fontSize: 20 }}>
                        <p style={{ color: mode === dark_mode ? '#fff' : '#EE31AF', textAlign: 'center', paddingRight: 10 }}>TXID:</p> <a href={localStorage.getItem('from') ? ` ${networks[localStorage.getItem('from')].explorer_url}/tx/${txnId.data.trx_id} ` : ` ${networks[from].explorer_url}/tx/${txnId.data.trx_id} `} target="_" style={{ color: mode === dark_mode ? '#fff' : '#EE31AF', fontSize: 20, fontWeight: "500", marginBottom: 10 }}>
                            {`${txnId.data.trx_id.slice(0, 8)}..${txnId.data.trx_id.slice(
                                -8
                            )
                                } `}
                        </a>
                        <div
                            data-tip
                            data-for="copys"
                            className="cursor_pointer"
                            style={{ paddingLeft: 10 }}
                            onClick={() => {
                                copy(txnId.data.trx_id);
                            }}
                        >
                            <BiWindowOpen
                                size={20}
                                color="#B2B2B2"
                            ></BiWindowOpen>
                        </div>
                        <ReactTooltip
                            isCapture={true}
                            globalEventOff="click"
                            event="click"
                            place="right"
                            id="copys"
                            type="info"
                            effect="solid"
                            className='reactTooltipCoppied'
                        // offset={{ left: -40, top: 40 }}
                        >
                            <span>Copied</span>
                        </ReactTooltip>
                    </div>
                    <Button
                        action={() => setModalOpen(false)}
                        style={{
                            padding: window.innerWidth < 768 ? '17px 0px' : '20px 0px',
                            fontSize: 18,
                            fontWeight: 700,
                            justifyContent: 'center',
                            alignitems: 'center',
                            textAlign: 'center',
                            backgroundColor: mode === dark_mode ? '#fff' : '#EE31AF',
                            color: mode === dark_mode ? '#EE31AF' : '#fff',
                            width: '80%',
                            display: 'flex',
                            marginLeft: '10%',
                            marginTop: '2%'

                        }}
                        type="fill"
                        title={"OK"}>
                    </Button>
                </div>
            </div>
        </div >
    )

    const clickHandler = async () => {
        let acc = await walletConnectHandler()
        // setAcc(acc)
        dispatch({ type: set_admin, payLoad: acc })
    }

    return (
        <>

            <div className='swap_body' style={{ filter: modalOpen ? `blur(10px)` : '' }}>
                <div className='swap_bg' style={{
                    height: "200px",
                    width: '50%',
                    position: 'absolute',
                    bottom: 0,
                    opacity: 0.05,
                }}>
                </div>
                <div className='container' >
                    <div className='row mx-auto container_wrapper'>
                        <div className='col-12 col-md-8 mx-auto'>
                            <div className='swap_content'>
                                <h3> </h3>
                                {/* <p>Trade without intermediaries through our exchange.</p> */}
                            </div>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <div className='swap_settings_holder'>
                                        <h4></h4>
                                    </div>
                                </div>

                                <div className='col-6'>
                                </div>
                            </div>

                            <div className={`row ${whiteBgClass} `}>
                                <div className='col-12'>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '96%' }}>
                                        <span className='swap_network'>Choose Network</span>
                                        {/* <div onClick={() => { addToken() }} style={{ cursor: "pointer", display: 'flex' }}><p style={{ margin: 0 }}><img style={{ width: 15, marginRight: 5 }} src={`${process.env.PUBLIC_URL} /Images/metamask - icon.png`}></img>Add Token</p></div> */}
                                    </div>
                                </div>
                                <div className='col-md-5'>
                                    <div className={swapFieldsrClass} onClick={(e) => {
                                        if (!loading) {
                                            setFromDropDown(!fromDropDown)
                                        }
                                    }} style={{ cursor: 'pointer' }}>
                                        <div className='home_Swap_option_holder' style={{ display: 'flex' }}>
                                            <OutsideClickHandler onOutsideClick={() => { setFromDropDown(false) }}>
                                                <div onClick={(e) => {
                                                    if (!loading) {
                                                        setFromDropDown(!fromDropDown)
                                                    }
                                                }}
                                                    className="home_Swap_option" >
                                                    <div>
                                                        <img src={localStorage.getItem("from") && networkPairs[[localStorage.getItem("from")]] ? networks[localStorage.getItem("from")].logo_url : networks[from].logo_url}></img>
                                                        <p style={{ color: mode === dark_mode ? '#fff' : '#EE31AF', fontSize: 14 }}>{localStorage.getItem("from") && networkPairs[[localStorage.getItem("from")]] ? networks[localStorage.getItem("from")].chainName : networks[from].chainName}</p>
                                                    </div>
                                                    <BsChevronDown />
                                                    <DropDown change={(val) => {
                                                        if (!loading) {
                                                            fromChangeHandler(val)
                                                        }
                                                    }} display={fromDropDown} items={availableFrom} />
                                                </div>
                                            </OutsideClickHandler>
                                        </div>
                                    </div>


                                </div>

                                <div className='col-md-2'>
                                    <div className='swap_icon_holder'>
                                        <BsArrowsAngleContract  onClick={() => {
                                            if (!loading) {
                                                fromChangeHandler(to); clear()
                                            }
                                        }} className={swapIcon}></BsArrowsAngleContract >
                                    </div>
                                </div>


                                <div className='col-md-5'>
                                    <div className={swapFieldsrClass} onClick={(e) => {
                                        if (!loading) {
                                            setToDropDown(!toDropDown)
                                        }
                                    }} style={{ cursor: 'pointer' }}>
                                        <div className='home_Swap_option_holder'>
                                            <OutsideClickHandler onOutsideClick={() => { setToDropDown(false) }}>
                                                <div onClick={(e) => {
                                                    if (!loading) {

                                                        setToDropDown(!toDropDown)
                                                    }
                                                }}
                                                    className="home_Swap_option" >
                                                    <div>
                                                        <img src={networks[to]?.logo_url}></img>
                                                        <p style={{ color: mode === dark_mode ? '#fff' : '#EE31AF', fontSize: 14 }}>{networks[to]?.chainName}</p>
                                                    </div>
                                                    <BsChevronDown />
                                                    <DropDown change={(val) => {
                                                        if (!loading) {
                                                            tochangeHandler(val)
                                                        }
                                                    }} display={toDropDown} items={availablePairs} />
                                                </div>
                                            </OutsideClickHandler>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-12'>
                                    <span className='swap_network'>You Send</span>
                                </div>

                                <div className='col-md-12'>
                                    <div className={swapFieldsrClass} style={{ borderColor: inputError ? 'red' : '' }}>
                                        <div className='home_Swap_from_holder'>
                                            <div className='swap_input_iconHolder'>
                                                <img src={localStorage.getItem("from") && networkPairs[[localStorage.getItem("from")]] ? networks[localStorage.getItem("from")].logo_url : networks[from].logo_url} height={25} />
                                                {/* {console.log(networks[from])} */}
                                                <p style={{ color: mode === dark_mode ? '#fff' : '#EE31AF' }}>{localStorage.getItem("from") && networkPairs[[localStorage.getItem("from")]] ? networks[localStorage.getItem("from")].token_name : networks[from].token_name}</p>
                                            </div>

                                            <input className={inputClass} style={{ width: '70%', color: mode === dark_mode ? '#fff' : '#EE31AF' }} value={amt == "" ? "" : amt.toString().match(/^\d+(?:\.\d{0,2})?/)} onChange={(e) => {
                                                changeHandler("AMT", e.target.value)
                                            }} type="text" placeholder='0.00' />
                                            <p style={{ fontWeight: 'bold', color: mode === dark_mode ? '#fff' : '#EE31AF' }} onClick={() => {
                                                setAmt(balance.toString())
                                                // setCurrPercent(val)
                                            }}>MAX</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-12' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '96%' }}>
                                    <span className='swap_network'>You Receive</span>

                                    {amt && <span style={{ color: mode === dark_mode ? '#fff' : '#EE31AF', fontSize: 14, fontWeight: 500, marginTop: '10px', fontSize: '12px' }}>
                                        FEE: {localStorage.getItem("from") ? `${networks[localStorage.getItem("from")].token_name} ${streamFeeStorage} ` :
                                            streamFee} | {localStorage.getItem("from") ?
                                                networks[localStorage.getItem("from")].metamask_symbol :
                                                networks[from].metamask_symbol} {localStorage.getItem("from") ?
                                                    networkPairs[localStorage.getItem("from")].available_pair[to]?.gas_fee :
                                                    networkPairs[from].available_pair[to]?.gas_fee}</span>}

                                </div>

                                <div className='col-md-12'>
                                    <div className={swapFieldsrClass}>
                                        <div className='home_Swap_from_holder'>
                                            <div className='swap_input_iconHolder'>
                                                <img src={networks[to].logo_url} height={25} />
                                                <p style={{ color: mode === dark_mode ? '#fff' : '#EE31AF' }}>{networks[to].token_name}</p>
                                            </div>
                                            {/* amt.toString().match(/^\d+(?:\.\d{0,5})?/) */}
                                            {localStorage.getItem('from') ?
                                                <input disabled={true} className={inputClass} style={{ width: '70%', color: mode === dark_mode ? '#fff' : '#EE31AF' }} value={amt == "" ? "" : (amt * (1 - (networks[localStorage.getItem('from')].stream_fee / 100))).toString().match(/^\d+(?:\.\d{0,2})?/)}
                                                    type="text" placeholder='0.00' /> :
                                                <input disabled={true} className={inputClass} style={{ width: '70%', color: mode === dark_mode ? '#fff' : '#EE31AF' }} value={amt == "" ? "" : (amt * (1 - (networks[from].stream_fee / 100))).toString().match(/^\d+(?:\.\d{0,2})?/)}
                                                    type="text" placeholder='0.00' />}
                                            {/* <input disabled={true} className={inputClass} style={{ width: '70%', color: mode === dark_mode ? '#fff' : '#EE31AF' }} value={amt == "" ? "" : (amt * (1 - (networks[from].stream_fee / 100))).toString().match(/^\d+(?:\.\d{0,2})?/)}
                                                type="text" placeholder='0.00' /> */}
                                            <p style={{ fontWeight: 'bold', color: mode === dark_mode ? '#fff' : '#EE31AF' }}>bbg</p>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className='col-12'>
                                    <span className='receiving_address'>Receiving Address</span>
                                </div> */}

                                {/* <div className='col-md-12'> */}
                                    {/* <div className={receivingAddressClass}> */}
                                        {/* <div className='swap_receiving_address'>
                                            <img src={metamaskIcon} height={25} />
                                        </div> */}
                                        {/* <p
                                            onClick={() => clickHandler()}
                                            disabled={true}
                                            className={inputClass}
                                            style={{ margin: 0, fontWeight: '500', width: '90%', color: mode === dark_mode ? '#fff' : '#EE31AF' }}
                                            value={userAcc}
                                            type="text" placeholder='Connect to metamask'>{userAcc ? userAcc : 'Connect to metamask'}</p> */}
                                    {/* </div> */}
                                {/* </div> */}

                                <div className='col-md-12'>
                                    <div className='swap_button_holder'>
                                        <Button
                                            className={`button ${color} `}
                                            loading={loading}
                                            disabled={acc === "" || balance === 0 || loading || amt < 1 || parseFloat(amt) > parseFloat(balance) ? true : false}
                                            action={() => { onSwap() }}
                                            style={{
                                                // padding: window.innerWidth < 768 ? '17px 0px' : '20px 0px',
                                                fontSize: 18,
                                                fontWeight: 700,
                                                backgroundColor: mode === dark_mode ? '#fff' : '#EE31AF',
                                                color: mode === dark_mode ? '#EE31AF' : '#fff'
                                            }}
                                            type="fill"
                                            title={acc === "" ? "Please Connect Your Wallet" : title}>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <ModalComponent width="30%" modalIsOpen={modalOpen} content={transactionDetailModal}></ModalComponent>
        </>
    )

}


export default Swap